import queryString from 'query-string';

export const parseUrl = (inputUrl) => {
  const url = queryString.parse(inputUrl);

  if (!url) {
    return { errorMessage: 'Invalid URL' };
  }

  const { 'session-id': sessionId, token, requestedFrom } = url;

  if (!sessionId || !token) {
    return { errorMessage: 'Invalid parameters' };
  }

  const regexp = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

  if (!sessionId.match(regexp)) {
    return { errorMessage: 'Invalid session identifier' };
  }

  if (token.length !== 24) {
    return { errorMessage: 'Invalid authentication token' };
  }

  return {
    sessionId,
    token,
    requestedFrom,
  };
};
